import {
  SafetyAlertModel,
  SafetyAlertNotificationModel,
} from '@casops/store/apis/personnelSafetyApi';
import { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { ColDef } from 'ag-grid-community';
import { GridControlled } from '@casops/components/tables/grid/GridControlled';
import { useAbsoluteTimePartialColDef } from '@casops/components/tables/cells/absolute-time/useAbsoluteTime';
import { EmailStatusCellRenderer } from '@casops/components/tables/cells/email-status/EmailStatusCellRenderer';
import { lockColumn } from '@casops/components/tables/grid/columnDefs';

interface SafetyAlertNotificationsProps {
  item?: SafetyAlertModel;
}

type Model = SafetyAlertNotificationModel;

const getRowId = (data: Model) => String(data.id);

const defaultColDef: ColDef<Model> = {
  ...lockColumn,
  sortable: true,
};

export const SafetyAlertNotifications = ({ item }: SafetyAlertNotificationsProps): ReactElement => {
  const { t } = useTranslation();

  const absoluteTimeColDef = useAbsoluteTimePartialColDef<Model>(' ');

  const columnDefs = useMemo<ColDef<SafetyAlertNotificationModel>[]>(
    () => [
      { field: 'n', headerName: t('Fields.To') },
      {
        field: 'st',
        headerName: t('Fields.EmailStatus'),
        cellRenderer: EmailStatusCellRenderer,
      },
      { field: 'ts', headerName: t('Fields.DateAndTime'), minWidth: 180, ...absoluteTimeColDef },
    ],
    [absoluteTimeColDef, t],
  );

  return item?.not ? (
    <GridControlled<SafetyAlertNotificationModel>
      sliceKey="safety-notification-records"
      autoheight={false}
      rowData={item.not}
      getRowId={getRowId}
      columnDefs={columnDefs}
      defaultColDef={defaultColDef}
    />
  ) : (
    <Skeleton width={300} height={50} />
  );
};
